<div class="row justify-content-between canvas">
    <div class="col-12">
        <div class="row lay" *ngFor="let lay of data?.layout">
            <div class="content-bloc col-{{el.column}}" *ngFor="let el of lay">
                <div *ngIf="getType(el.contentRef) == 'TEXT'" id="{{el.contentRef}}" class="html-content content-bloc-element"></div>
                <div *ngIf="getType(el.contentRef) == 'VIDEO'" id="{{el.contentRef}}" class="iframe content-bloc-element" ></div>
                <div *ngIf="getType(el.contentRef) == 'DOCUMENT'" id="{{getContent(el.contentRef).id}}" class="document content-bloc-element"></div>
            </div>
        </div>
    </div>
</div>